import { FC, ReactElement } from 'react';
import { useRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';

import { eventsSnackBarAtom } from '../../../data-access';
import { CalendarSnackIcon, CalendarSnackType } from '../../../data-access/types';
import { useCalendarSyncErrorSnackbar } from '../../../hooks';
import { ReactComponent as CalendarIcon } from '../../../assets/tabs/settings-tab/calendar-icon.svg';
import { ReactComponent as TodoIcon } from '../../../assets/tabs/settings-tab/todo-icon.svg';
import StyledSnackBar from './StyledSnackBar';

const TYPE_COLORS: Record<CalendarSnackType, string> = {
  success: '#3d7a4a',
  loading: '#5c6bc0',
  warning: '#c9941a',
  error: '#c0392b',
};

const ICONS: Record<CalendarSnackIcon, ReactElement> = {
  calendar: <CalendarIcon />,
  task: <TodoIcon />,
};

const CalendarEventSnackBar: FC = () => {
  const { t } = useTranslation();
  const [eventsSnackbar, setEventsSnackbar] = useRecoilState(eventsSnackBarAtom);
  useCalendarSyncErrorSnackbar();

  const handleClose = () => setEventsSnackbar(null);

  return (
    <StyledSnackBar
      open={!!eventsSnackbar}
      message={eventsSnackbar?.message}
      icon={ICONS[eventsSnackbar?.icon ?? 'calendar']}
      color={TYPE_COLORS[eventsSnackbar?.type ?? 'success']}
      actionLabel={eventsSnackbar?.actionLabel}
      onAction={eventsSnackbar?.onPress}
      onClose={handleClose}
      autoHideDuration={
        eventsSnackbar?.autoHideDuration === 'disable'
          ? null
          : eventsSnackbar?.autoHideDuration || 1500
      }
      closeAriaLabel={t('data.common.close')}
      closeOnTimeoutOnly
    />
  );
};

export default CalendarEventSnackBar;
